/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedQuery<InputType, OutputType> = string & {
  __generatedQueryInput: InputType;
  __generatedQueryOutput: OutputType;
};

export const getUser = /* GraphQL */ `query GetUser($id: ID!) {
  getUser(id: $id) {
    id
    email
    name
    transcriptionTime
    transcriptionsCreated
    casesCreated
    templatesUsed
    currentTranscriptionsCreated
    currentCasesCreated
    currentTemplatesUsed
    storeReviewRequestedAt
    pims
    audioRetentionPeriod
    defaultNormalText
    stripeCustomerId
    groups
    owner
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.GetUserQueryVariables, APITypes.GetUserQuery>;
export const listUsers = /* GraphQL */ `query ListUsers(
  $filter: ModelUserFilterInput
  $limit: Int
  $nextToken: String
) {
  listUsers(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      email
      name
      transcriptionTime
      transcriptionsCreated
      casesCreated
      templatesUsed
      currentTranscriptionsCreated
      currentCasesCreated
      currentTemplatesUsed
      storeReviewRequestedAt
      pims
      audioRetentionPeriod
      defaultNormalText
      stripeCustomerId
      groups
      owner
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.ListUsersQueryVariables, APITypes.ListUsersQuery>;
export const syncUsers = /* GraphQL */ `query SyncUsers(
  $filter: ModelUserFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncUsers(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      email
      name
      transcriptionTime
      transcriptionsCreated
      casesCreated
      templatesUsed
      currentTranscriptionsCreated
      currentCasesCreated
      currentTemplatesUsed
      storeReviewRequestedAt
      pims
      audioRetentionPeriod
      defaultNormalText
      stripeCustomerId
      groups
      owner
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.SyncUsersQueryVariables, APITypes.SyncUsersQuery>;
export const getLocation = /* GraphQL */ `query GetLocation($id: ID!) {
  getLocation(id: $id) {
    id
    name
    address
    patients {
      items {
        id
        name
        client
        image
        s3Image
        pinned
        archived
        lID
        groups
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    cases {
      items {
        id
        title
        description
        historySummary
        planSummary
        communicationSummary
        overviewSummary
        typedNotes
        caseTemplateId
        templateData
        lID
        pID
        groups
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    templates {
      items {
        id
        name
        pinned
        archived
        advanced
        lID
        sectionOrder
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    recordings {
      items {
        id
        name
        storagePath
        useTemplate
        duration
        text
        segments
        summary
        lID
        cID
        dID
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    billingcodes {
      items {
        id
        code
        description
        keywords
        price
        lID
        groups
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    groupUsers
    groupAdmins
    groups
    owners
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetLocationQueryVariables,
  APITypes.GetLocationQuery
>;
export const listLocations = /* GraphQL */ `query ListLocations(
  $filter: ModelLocationFilterInput
  $limit: Int
  $nextToken: String
) {
  listLocations(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      address
      patients {
        nextToken
        startedAt
        __typename
      }
      cases {
        nextToken
        startedAt
        __typename
      }
      templates {
        nextToken
        startedAt
        __typename
      }
      recordings {
        nextToken
        startedAt
        __typename
      }
      billingcodes {
        nextToken
        startedAt
        __typename
      }
      groupUsers
      groupAdmins
      groups
      owners
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListLocationsQueryVariables,
  APITypes.ListLocationsQuery
>;
export const syncLocations = /* GraphQL */ `query SyncLocations(
  $filter: ModelLocationFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncLocations(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      name
      address
      patients {
        nextToken
        startedAt
        __typename
      }
      cases {
        nextToken
        startedAt
        __typename
      }
      templates {
        nextToken
        startedAt
        __typename
      }
      recordings {
        nextToken
        startedAt
        __typename
      }
      billingcodes {
        nextToken
        startedAt
        __typename
      }
      groupUsers
      groupAdmins
      groups
      owners
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncLocationsQueryVariables,
  APITypes.SyncLocationsQuery
>;
export const getPatient = /* GraphQL */ `query GetPatient($id: ID!) {
  getPatient(id: $id) {
    id
    name
    client
    image
    s3Image
    pinned
    archived
    location {
      id
      name
      address
      patients {
        nextToken
        startedAt
        __typename
      }
      cases {
        nextToken
        startedAt
        __typename
      }
      templates {
        nextToken
        startedAt
        __typename
      }
      recordings {
        nextToken
        startedAt
        __typename
      }
      billingcodes {
        nextToken
        startedAt
        __typename
      }
      groupUsers
      groupAdmins
      groups
      owners
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    lID
    cases {
      items {
        id
        title
        description
        historySummary
        planSummary
        communicationSummary
        overviewSummary
        typedNotes
        caseTemplateId
        templateData
        lID
        pID
        groups
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    details {
      items {
        id
        type
        text
        summary
        isSummarized
        pID
        cID
        groups
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        detailsRecordingId
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    groups
    owners
    updatedAt
    createdAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetPatientQueryVariables,
  APITypes.GetPatientQuery
>;
export const listPatients = /* GraphQL */ `query ListPatients(
  $filter: ModelPatientFilterInput
  $limit: Int
  $nextToken: String
) {
  listPatients(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      client
      image
      s3Image
      pinned
      archived
      location {
        id
        name
        address
        groupUsers
        groupAdmins
        groups
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      lID
      cases {
        nextToken
        startedAt
        __typename
      }
      details {
        nextToken
        startedAt
        __typename
      }
      groups
      owners
      updatedAt
      createdAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPatientsQueryVariables,
  APITypes.ListPatientsQuery
>;
export const syncPatients = /* GraphQL */ `query SyncPatients(
  $filter: ModelPatientFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncPatients(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      name
      client
      image
      s3Image
      pinned
      archived
      location {
        id
        name
        address
        groupUsers
        groupAdmins
        groups
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      lID
      cases {
        nextToken
        startedAt
        __typename
      }
      details {
        nextToken
        startedAt
        __typename
      }
      groups
      owners
      updatedAt
      createdAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncPatientsQueryVariables,
  APITypes.SyncPatientsQuery
>;
export const patientsByLIDAndUpdatedAt = /* GraphQL */ `query PatientsByLIDAndUpdatedAt(
  $lID: ID!
  $updatedAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelPatientFilterInput
  $limit: Int
  $nextToken: String
) {
  patientsByLIDAndUpdatedAt(
    lID: $lID
    updatedAt: $updatedAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      name
      client
      image
      s3Image
      pinned
      archived
      location {
        id
        name
        address
        groupUsers
        groupAdmins
        groups
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      lID
      cases {
        nextToken
        startedAt
        __typename
      }
      details {
        nextToken
        startedAt
        __typename
      }
      groups
      owners
      updatedAt
      createdAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.PatientsByLIDAndUpdatedAtQueryVariables,
  APITypes.PatientsByLIDAndUpdatedAtQuery
>;
export const getCase = /* GraphQL */ `query GetCase($id: ID!) {
  getCase(id: $id) {
    id
    title
    description
    historySummary
    planSummary
    communicationSummary
    overviewSummary
    typedNotes
    template {
      id
      name
      pinned
      archived
      advanced
      location {
        id
        name
        address
        groupUsers
        groupAdmins
        groups
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      lID
      sections {
        nextToken
        startedAt
        __typename
      }
      sectionOrder
      subsections {
        nextToken
        startedAt
        __typename
      }
      fields {
        nextToken
        startedAt
        __typename
      }
      textboxes {
        nextToken
        startedAt
        __typename
      }
      owners
      updatedAt
      createdAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    caseTemplateId
    templateData
    location {
      id
      name
      address
      patients {
        nextToken
        startedAt
        __typename
      }
      cases {
        nextToken
        startedAt
        __typename
      }
      templates {
        nextToken
        startedAt
        __typename
      }
      recordings {
        nextToken
        startedAt
        __typename
      }
      billingcodes {
        nextToken
        startedAt
        __typename
      }
      groupUsers
      groupAdmins
      groups
      owners
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    lID
    patient {
      id
      name
      client
      image
      s3Image
      pinned
      archived
      location {
        id
        name
        address
        groupUsers
        groupAdmins
        groups
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      lID
      cases {
        nextToken
        startedAt
        __typename
      }
      details {
        nextToken
        startedAt
        __typename
      }
      groups
      owners
      updatedAt
      createdAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    pID
    details {
      items {
        id
        type
        text
        summary
        isSummarized
        pID
        cID
        groups
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        detailsRecordingId
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    recordings {
      items {
        id
        name
        storagePath
        useTemplate
        duration
        text
        segments
        summary
        lID
        cID
        dID
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    groups
    owners
    updatedAt
    createdAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.GetCaseQueryVariables, APITypes.GetCaseQuery>;
export const listCases = /* GraphQL */ `query ListCases(
  $filter: ModelCaseFilterInput
  $limit: Int
  $nextToken: String
) {
  listCases(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      title
      description
      historySummary
      planSummary
      communicationSummary
      overviewSummary
      typedNotes
      template {
        id
        name
        pinned
        archived
        advanced
        lID
        sectionOrder
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      caseTemplateId
      templateData
      location {
        id
        name
        address
        groupUsers
        groupAdmins
        groups
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      lID
      patient {
        id
        name
        client
        image
        s3Image
        pinned
        archived
        lID
        groups
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      pID
      details {
        nextToken
        startedAt
        __typename
      }
      recordings {
        nextToken
        startedAt
        __typename
      }
      groups
      owners
      updatedAt
      createdAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.ListCasesQueryVariables, APITypes.ListCasesQuery>;
export const syncCases = /* GraphQL */ `query SyncCases(
  $filter: ModelCaseFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncCases(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      title
      description
      historySummary
      planSummary
      communicationSummary
      overviewSummary
      typedNotes
      template {
        id
        name
        pinned
        archived
        advanced
        lID
        sectionOrder
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      caseTemplateId
      templateData
      location {
        id
        name
        address
        groupUsers
        groupAdmins
        groups
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      lID
      patient {
        id
        name
        client
        image
        s3Image
        pinned
        archived
        lID
        groups
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      pID
      details {
        nextToken
        startedAt
        __typename
      }
      recordings {
        nextToken
        startedAt
        __typename
      }
      groups
      owners
      updatedAt
      createdAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.SyncCasesQueryVariables, APITypes.SyncCasesQuery>;
export const casesByLIDAndUpdatedAt = /* GraphQL */ `query CasesByLIDAndUpdatedAt(
  $lID: ID!
  $updatedAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelCaseFilterInput
  $limit: Int
  $nextToken: String
) {
  casesByLIDAndUpdatedAt(
    lID: $lID
    updatedAt: $updatedAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      title
      description
      historySummary
      planSummary
      communicationSummary
      overviewSummary
      typedNotes
      template {
        id
        name
        pinned
        archived
        advanced
        lID
        sectionOrder
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      caseTemplateId
      templateData
      location {
        id
        name
        address
        groupUsers
        groupAdmins
        groups
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      lID
      patient {
        id
        name
        client
        image
        s3Image
        pinned
        archived
        lID
        groups
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      pID
      details {
        nextToken
        startedAt
        __typename
      }
      recordings {
        nextToken
        startedAt
        __typename
      }
      groups
      owners
      updatedAt
      createdAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.CasesByLIDAndUpdatedAtQueryVariables,
  APITypes.CasesByLIDAndUpdatedAtQuery
>;
export const casesByPIDAndCreatedAt = /* GraphQL */ `query CasesByPIDAndCreatedAt(
  $pID: ID!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelCaseFilterInput
  $limit: Int
  $nextToken: String
) {
  casesByPIDAndCreatedAt(
    pID: $pID
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      title
      description
      historySummary
      planSummary
      communicationSummary
      overviewSummary
      typedNotes
      template {
        id
        name
        pinned
        archived
        advanced
        lID
        sectionOrder
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      caseTemplateId
      templateData
      location {
        id
        name
        address
        groupUsers
        groupAdmins
        groups
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      lID
      patient {
        id
        name
        client
        image
        s3Image
        pinned
        archived
        lID
        groups
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      pID
      details {
        nextToken
        startedAt
        __typename
      }
      recordings {
        nextToken
        startedAt
        __typename
      }
      groups
      owners
      updatedAt
      createdAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.CasesByPIDAndCreatedAtQueryVariables,
  APITypes.CasesByPIDAndCreatedAtQuery
>;
export const getDetails = /* GraphQL */ `query GetDetails($id: ID!) {
  getDetails(id: $id) {
    id
    type
    text
    summary
    isSummarized
    patient {
      id
      name
      client
      image
      s3Image
      pinned
      archived
      location {
        id
        name
        address
        groupUsers
        groupAdmins
        groups
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      lID
      cases {
        nextToken
        startedAt
        __typename
      }
      details {
        nextToken
        startedAt
        __typename
      }
      groups
      owners
      updatedAt
      createdAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    pID
    case {
      id
      title
      description
      historySummary
      planSummary
      communicationSummary
      overviewSummary
      typedNotes
      template {
        id
        name
        pinned
        archived
        advanced
        lID
        sectionOrder
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      caseTemplateId
      templateData
      location {
        id
        name
        address
        groupUsers
        groupAdmins
        groups
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      lID
      patient {
        id
        name
        client
        image
        s3Image
        pinned
        archived
        lID
        groups
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      pID
      details {
        nextToken
        startedAt
        __typename
      }
      recordings {
        nextToken
        startedAt
        __typename
      }
      groups
      owners
      updatedAt
      createdAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    cID
    recording {
      id
      name
      storagePath
      useTemplate
      duration
      text
      segments
      summary
      location {
        id
        name
        address
        groupUsers
        groupAdmins
        groups
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      lID
      case {
        id
        title
        description
        historySummary
        planSummary
        communicationSummary
        overviewSummary
        typedNotes
        caseTemplateId
        templateData
        lID
        pID
        groups
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      cID
      details {
        id
        type
        text
        summary
        isSummarized
        pID
        cID
        groups
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        detailsRecordingId
        __typename
      }
      dID
      owners
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    groups
    owners
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    detailsRecordingId
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetDetailsQueryVariables,
  APITypes.GetDetailsQuery
>;
export const listDetails = /* GraphQL */ `query ListDetails(
  $filter: ModelDetailsFilterInput
  $limit: Int
  $nextToken: String
) {
  listDetails(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      type
      text
      summary
      isSummarized
      patient {
        id
        name
        client
        image
        s3Image
        pinned
        archived
        lID
        groups
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      pID
      case {
        id
        title
        description
        historySummary
        planSummary
        communicationSummary
        overviewSummary
        typedNotes
        caseTemplateId
        templateData
        lID
        pID
        groups
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      cID
      recording {
        id
        name
        storagePath
        useTemplate
        duration
        text
        segments
        summary
        lID
        cID
        dID
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      groups
      owners
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      detailsRecordingId
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListDetailsQueryVariables,
  APITypes.ListDetailsQuery
>;
export const syncDetails = /* GraphQL */ `query SyncDetails(
  $filter: ModelDetailsFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncDetails(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      type
      text
      summary
      isSummarized
      patient {
        id
        name
        client
        image
        s3Image
        pinned
        archived
        lID
        groups
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      pID
      case {
        id
        title
        description
        historySummary
        planSummary
        communicationSummary
        overviewSummary
        typedNotes
        caseTemplateId
        templateData
        lID
        pID
        groups
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      cID
      recording {
        id
        name
        storagePath
        useTemplate
        duration
        text
        segments
        summary
        lID
        cID
        dID
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      groups
      owners
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      detailsRecordingId
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncDetailsQueryVariables,
  APITypes.SyncDetailsQuery
>;
export const detailsByPID = /* GraphQL */ `query DetailsByPID(
  $pID: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelDetailsFilterInput
  $limit: Int
  $nextToken: String
) {
  detailsByPID(
    pID: $pID
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      type
      text
      summary
      isSummarized
      patient {
        id
        name
        client
        image
        s3Image
        pinned
        archived
        lID
        groups
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      pID
      case {
        id
        title
        description
        historySummary
        planSummary
        communicationSummary
        overviewSummary
        typedNotes
        caseTemplateId
        templateData
        lID
        pID
        groups
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      cID
      recording {
        id
        name
        storagePath
        useTemplate
        duration
        text
        segments
        summary
        lID
        cID
        dID
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      groups
      owners
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      detailsRecordingId
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.DetailsByPIDQueryVariables,
  APITypes.DetailsByPIDQuery
>;
export const detailsByCID = /* GraphQL */ `query DetailsByCID(
  $cID: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelDetailsFilterInput
  $limit: Int
  $nextToken: String
) {
  detailsByCID(
    cID: $cID
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      type
      text
      summary
      isSummarized
      patient {
        id
        name
        client
        image
        s3Image
        pinned
        archived
        lID
        groups
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      pID
      case {
        id
        title
        description
        historySummary
        planSummary
        communicationSummary
        overviewSummary
        typedNotes
        caseTemplateId
        templateData
        lID
        pID
        groups
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      cID
      recording {
        id
        name
        storagePath
        useTemplate
        duration
        text
        segments
        summary
        lID
        cID
        dID
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      groups
      owners
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      detailsRecordingId
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.DetailsByCIDQueryVariables,
  APITypes.DetailsByCIDQuery
>;
export const getRecording = /* GraphQL */ `query GetRecording($id: ID!) {
  getRecording(id: $id) {
    id
    name
    storagePath
    useTemplate
    duration
    text
    segments
    summary
    location {
      id
      name
      address
      patients {
        nextToken
        startedAt
        __typename
      }
      cases {
        nextToken
        startedAt
        __typename
      }
      templates {
        nextToken
        startedAt
        __typename
      }
      recordings {
        nextToken
        startedAt
        __typename
      }
      billingcodes {
        nextToken
        startedAt
        __typename
      }
      groupUsers
      groupAdmins
      groups
      owners
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    lID
    case {
      id
      title
      description
      historySummary
      planSummary
      communicationSummary
      overviewSummary
      typedNotes
      template {
        id
        name
        pinned
        archived
        advanced
        lID
        sectionOrder
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      caseTemplateId
      templateData
      location {
        id
        name
        address
        groupUsers
        groupAdmins
        groups
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      lID
      patient {
        id
        name
        client
        image
        s3Image
        pinned
        archived
        lID
        groups
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      pID
      details {
        nextToken
        startedAt
        __typename
      }
      recordings {
        nextToken
        startedAt
        __typename
      }
      groups
      owners
      updatedAt
      createdAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    cID
    details {
      id
      type
      text
      summary
      isSummarized
      patient {
        id
        name
        client
        image
        s3Image
        pinned
        archived
        lID
        groups
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      pID
      case {
        id
        title
        description
        historySummary
        planSummary
        communicationSummary
        overviewSummary
        typedNotes
        caseTemplateId
        templateData
        lID
        pID
        groups
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      cID
      recording {
        id
        name
        storagePath
        useTemplate
        duration
        text
        segments
        summary
        lID
        cID
        dID
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      groups
      owners
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      detailsRecordingId
      __typename
    }
    dID
    owners
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetRecordingQueryVariables,
  APITypes.GetRecordingQuery
>;
export const listRecordings = /* GraphQL */ `query ListRecordings(
  $filter: ModelRecordingFilterInput
  $limit: Int
  $nextToken: String
) {
  listRecordings(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      storagePath
      useTemplate
      duration
      text
      segments
      summary
      location {
        id
        name
        address
        groupUsers
        groupAdmins
        groups
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      lID
      case {
        id
        title
        description
        historySummary
        planSummary
        communicationSummary
        overviewSummary
        typedNotes
        caseTemplateId
        templateData
        lID
        pID
        groups
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      cID
      details {
        id
        type
        text
        summary
        isSummarized
        pID
        cID
        groups
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        detailsRecordingId
        __typename
      }
      dID
      owners
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListRecordingsQueryVariables,
  APITypes.ListRecordingsQuery
>;
export const syncRecordings = /* GraphQL */ `query SyncRecordings(
  $filter: ModelRecordingFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncRecordings(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      name
      storagePath
      useTemplate
      duration
      text
      segments
      summary
      location {
        id
        name
        address
        groupUsers
        groupAdmins
        groups
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      lID
      case {
        id
        title
        description
        historySummary
        planSummary
        communicationSummary
        overviewSummary
        typedNotes
        caseTemplateId
        templateData
        lID
        pID
        groups
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      cID
      details {
        id
        type
        text
        summary
        isSummarized
        pID
        cID
        groups
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        detailsRecordingId
        __typename
      }
      dID
      owners
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncRecordingsQueryVariables,
  APITypes.SyncRecordingsQuery
>;
export const recordingsByLID = /* GraphQL */ `query RecordingsByLID(
  $lID: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelRecordingFilterInput
  $limit: Int
  $nextToken: String
) {
  recordingsByLID(
    lID: $lID
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      name
      storagePath
      useTemplate
      duration
      text
      segments
      summary
      location {
        id
        name
        address
        groupUsers
        groupAdmins
        groups
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      lID
      case {
        id
        title
        description
        historySummary
        planSummary
        communicationSummary
        overviewSummary
        typedNotes
        caseTemplateId
        templateData
        lID
        pID
        groups
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      cID
      details {
        id
        type
        text
        summary
        isSummarized
        pID
        cID
        groups
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        detailsRecordingId
        __typename
      }
      dID
      owners
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.RecordingsByLIDQueryVariables,
  APITypes.RecordingsByLIDQuery
>;
export const recordingsByCID = /* GraphQL */ `query RecordingsByCID(
  $cID: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelRecordingFilterInput
  $limit: Int
  $nextToken: String
) {
  recordingsByCID(
    cID: $cID
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      name
      storagePath
      useTemplate
      duration
      text
      segments
      summary
      location {
        id
        name
        address
        groupUsers
        groupAdmins
        groups
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      lID
      case {
        id
        title
        description
        historySummary
        planSummary
        communicationSummary
        overviewSummary
        typedNotes
        caseTemplateId
        templateData
        lID
        pID
        groups
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      cID
      details {
        id
        type
        text
        summary
        isSummarized
        pID
        cID
        groups
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        detailsRecordingId
        __typename
      }
      dID
      owners
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.RecordingsByCIDQueryVariables,
  APITypes.RecordingsByCIDQuery
>;
export const recordingsByDID = /* GraphQL */ `query RecordingsByDID(
  $dID: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelRecordingFilterInput
  $limit: Int
  $nextToken: String
) {
  recordingsByDID(
    dID: $dID
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      name
      storagePath
      useTemplate
      duration
      text
      segments
      summary
      location {
        id
        name
        address
        groupUsers
        groupAdmins
        groups
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      lID
      case {
        id
        title
        description
        historySummary
        planSummary
        communicationSummary
        overviewSummary
        typedNotes
        caseTemplateId
        templateData
        lID
        pID
        groups
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      cID
      details {
        id
        type
        text
        summary
        isSummarized
        pID
        cID
        groups
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        detailsRecordingId
        __typename
      }
      dID
      owners
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.RecordingsByDIDQueryVariables,
  APITypes.RecordingsByDIDQuery
>;
export const getBillingCodes = /* GraphQL */ `query GetBillingCodes($id: ID!) {
  getBillingCodes(id: $id) {
    id
    code
    description
    keywords
    price
    location {
      id
      name
      address
      patients {
        nextToken
        startedAt
        __typename
      }
      cases {
        nextToken
        startedAt
        __typename
      }
      templates {
        nextToken
        startedAt
        __typename
      }
      recordings {
        nextToken
        startedAt
        __typename
      }
      billingcodes {
        nextToken
        startedAt
        __typename
      }
      groupUsers
      groupAdmins
      groups
      owners
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    lID
    groups
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetBillingCodesQueryVariables,
  APITypes.GetBillingCodesQuery
>;
export const listBillingCodes = /* GraphQL */ `query ListBillingCodes(
  $filter: ModelBillingCodesFilterInput
  $limit: Int
  $nextToken: String
) {
  listBillingCodes(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      code
      description
      keywords
      price
      location {
        id
        name
        address
        groupUsers
        groupAdmins
        groups
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      lID
      groups
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListBillingCodesQueryVariables,
  APITypes.ListBillingCodesQuery
>;
export const syncBillingCodes = /* GraphQL */ `query SyncBillingCodes(
  $filter: ModelBillingCodesFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncBillingCodes(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      code
      description
      keywords
      price
      location {
        id
        name
        address
        groupUsers
        groupAdmins
        groups
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      lID
      groups
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncBillingCodesQueryVariables,
  APITypes.SyncBillingCodesQuery
>;
export const billingCodesByLID = /* GraphQL */ `query BillingCodesByLID(
  $lID: ID!
  $sortDirection: ModelSortDirection
  $filter: ModelBillingCodesFilterInput
  $limit: Int
  $nextToken: String
) {
  billingCodesByLID(
    lID: $lID
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      code
      description
      keywords
      price
      location {
        id
        name
        address
        groupUsers
        groupAdmins
        groups
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      lID
      groups
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.BillingCodesByLIDQueryVariables,
  APITypes.BillingCodesByLIDQuery
>;
export const getTemplate = /* GraphQL */ `query GetTemplate($id: ID!) {
  getTemplate(id: $id) {
    id
    name
    pinned
    archived
    advanced
    location {
      id
      name
      address
      patients {
        nextToken
        startedAt
        __typename
      }
      cases {
        nextToken
        startedAt
        __typename
      }
      templates {
        nextToken
        startedAt
        __typename
      }
      recordings {
        nextToken
        startedAt
        __typename
      }
      billingcodes {
        nextToken
        startedAt
        __typename
      }
      groupUsers
      groupAdmins
      groups
      owners
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    lID
    sections {
      items {
        id
        name
        isSimple
        tID
        subsectionOrder
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    sectionOrder
    subsections {
      items {
        id
        name
        sID
        fieldOrder
        tID
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    fields {
      items {
        id
        name
        value
        ssID
        tID
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    textboxes {
      items {
        id
        value
        sID
        tID
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    owners
    updatedAt
    createdAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetTemplateQueryVariables,
  APITypes.GetTemplateQuery
>;
export const listTemplates = /* GraphQL */ `query ListTemplates(
  $filter: ModelTemplateFilterInput
  $limit: Int
  $nextToken: String
) {
  listTemplates(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      pinned
      archived
      advanced
      location {
        id
        name
        address
        groupUsers
        groupAdmins
        groups
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      lID
      sections {
        nextToken
        startedAt
        __typename
      }
      sectionOrder
      subsections {
        nextToken
        startedAt
        __typename
      }
      fields {
        nextToken
        startedAt
        __typename
      }
      textboxes {
        nextToken
        startedAt
        __typename
      }
      owners
      updatedAt
      createdAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListTemplatesQueryVariables,
  APITypes.ListTemplatesQuery
>;
export const syncTemplates = /* GraphQL */ `query SyncTemplates(
  $filter: ModelTemplateFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncTemplates(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      name
      pinned
      archived
      advanced
      location {
        id
        name
        address
        groupUsers
        groupAdmins
        groups
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      lID
      sections {
        nextToken
        startedAt
        __typename
      }
      sectionOrder
      subsections {
        nextToken
        startedAt
        __typename
      }
      fields {
        nextToken
        startedAt
        __typename
      }
      textboxes {
        nextToken
        startedAt
        __typename
      }
      owners
      updatedAt
      createdAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncTemplatesQueryVariables,
  APITypes.SyncTemplatesQuery
>;
export const templatesByLIDAndUpdatedAt = /* GraphQL */ `query TemplatesByLIDAndUpdatedAt(
  $lID: ID!
  $updatedAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelTemplateFilterInput
  $limit: Int
  $nextToken: String
) {
  templatesByLIDAndUpdatedAt(
    lID: $lID
    updatedAt: $updatedAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      name
      pinned
      archived
      advanced
      location {
        id
        name
        address
        groupUsers
        groupAdmins
        groups
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      lID
      sections {
        nextToken
        startedAt
        __typename
      }
      sectionOrder
      subsections {
        nextToken
        startedAt
        __typename
      }
      fields {
        nextToken
        startedAt
        __typename
      }
      textboxes {
        nextToken
        startedAt
        __typename
      }
      owners
      updatedAt
      createdAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.TemplatesByLIDAndUpdatedAtQueryVariables,
  APITypes.TemplatesByLIDAndUpdatedAtQuery
>;
export const getTemplateSection = /* GraphQL */ `query GetTemplateSection($id: ID!) {
  getTemplateSection(id: $id) {
    id
    name
    isSimple
    textboxes {
      items {
        id
        value
        sID
        tID
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    template {
      id
      name
      pinned
      archived
      advanced
      location {
        id
        name
        address
        groupUsers
        groupAdmins
        groups
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      lID
      sections {
        nextToken
        startedAt
        __typename
      }
      sectionOrder
      subsections {
        nextToken
        startedAt
        __typename
      }
      fields {
        nextToken
        startedAt
        __typename
      }
      textboxes {
        nextToken
        startedAt
        __typename
      }
      owners
      updatedAt
      createdAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    tID
    subsections {
      items {
        id
        name
        sID
        fieldOrder
        tID
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    subsectionOrder
    owners
    updatedAt
    createdAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetTemplateSectionQueryVariables,
  APITypes.GetTemplateSectionQuery
>;
export const listTemplateSections = /* GraphQL */ `query ListTemplateSections(
  $filter: ModelTemplateSectionFilterInput
  $limit: Int
  $nextToken: String
) {
  listTemplateSections(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      isSimple
      textboxes {
        nextToken
        startedAt
        __typename
      }
      template {
        id
        name
        pinned
        archived
        advanced
        lID
        sectionOrder
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      tID
      subsections {
        nextToken
        startedAt
        __typename
      }
      subsectionOrder
      owners
      updatedAt
      createdAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListTemplateSectionsQueryVariables,
  APITypes.ListTemplateSectionsQuery
>;
export const syncTemplateSections = /* GraphQL */ `query SyncTemplateSections(
  $filter: ModelTemplateSectionFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncTemplateSections(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      name
      isSimple
      textboxes {
        nextToken
        startedAt
        __typename
      }
      template {
        id
        name
        pinned
        archived
        advanced
        lID
        sectionOrder
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      tID
      subsections {
        nextToken
        startedAt
        __typename
      }
      subsectionOrder
      owners
      updatedAt
      createdAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncTemplateSectionsQueryVariables,
  APITypes.SyncTemplateSectionsQuery
>;
export const templateSectionsByTIDAndUpdatedAt = /* GraphQL */ `query TemplateSectionsByTIDAndUpdatedAt(
  $tID: ID!
  $updatedAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelTemplateSectionFilterInput
  $limit: Int
  $nextToken: String
) {
  templateSectionsByTIDAndUpdatedAt(
    tID: $tID
    updatedAt: $updatedAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      name
      isSimple
      textboxes {
        nextToken
        startedAt
        __typename
      }
      template {
        id
        name
        pinned
        archived
        advanced
        lID
        sectionOrder
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      tID
      subsections {
        nextToken
        startedAt
        __typename
      }
      subsectionOrder
      owners
      updatedAt
      createdAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.TemplateSectionsByTIDAndUpdatedAtQueryVariables,
  APITypes.TemplateSectionsByTIDAndUpdatedAtQuery
>;
export const getTemplateTextbox = /* GraphQL */ `query GetTemplateTextbox($id: ID!) {
  getTemplateTextbox(id: $id) {
    id
    value
    section {
      id
      name
      isSimple
      textboxes {
        nextToken
        startedAt
        __typename
      }
      template {
        id
        name
        pinned
        archived
        advanced
        lID
        sectionOrder
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      tID
      subsections {
        nextToken
        startedAt
        __typename
      }
      subsectionOrder
      owners
      updatedAt
      createdAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    sID
    template {
      id
      name
      pinned
      archived
      advanced
      location {
        id
        name
        address
        groupUsers
        groupAdmins
        groups
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      lID
      sections {
        nextToken
        startedAt
        __typename
      }
      sectionOrder
      subsections {
        nextToken
        startedAt
        __typename
      }
      fields {
        nextToken
        startedAt
        __typename
      }
      textboxes {
        nextToken
        startedAt
        __typename
      }
      owners
      updatedAt
      createdAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    tID
    owners
    updatedAt
    createdAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetTemplateTextboxQueryVariables,
  APITypes.GetTemplateTextboxQuery
>;
export const listTemplateTextboxes = /* GraphQL */ `query ListTemplateTextboxes(
  $filter: ModelTemplateTextboxFilterInput
  $limit: Int
  $nextToken: String
) {
  listTemplateTextboxes(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      value
      section {
        id
        name
        isSimple
        tID
        subsectionOrder
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      sID
      template {
        id
        name
        pinned
        archived
        advanced
        lID
        sectionOrder
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      tID
      owners
      updatedAt
      createdAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListTemplateTextboxesQueryVariables,
  APITypes.ListTemplateTextboxesQuery
>;
export const syncTemplateTextboxes = /* GraphQL */ `query SyncTemplateTextboxes(
  $filter: ModelTemplateTextboxFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncTemplateTextboxes(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      value
      section {
        id
        name
        isSimple
        tID
        subsectionOrder
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      sID
      template {
        id
        name
        pinned
        archived
        advanced
        lID
        sectionOrder
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      tID
      owners
      updatedAt
      createdAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncTemplateTextboxesQueryVariables,
  APITypes.SyncTemplateTextboxesQuery
>;
export const templateTextboxesBySIDAndUpdatedAt = /* GraphQL */ `query TemplateTextboxesBySIDAndUpdatedAt(
  $sID: ID!
  $updatedAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelTemplateTextboxFilterInput
  $limit: Int
  $nextToken: String
) {
  templateTextboxesBySIDAndUpdatedAt(
    sID: $sID
    updatedAt: $updatedAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      value
      section {
        id
        name
        isSimple
        tID
        subsectionOrder
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      sID
      template {
        id
        name
        pinned
        archived
        advanced
        lID
        sectionOrder
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      tID
      owners
      updatedAt
      createdAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.TemplateTextboxesBySIDAndUpdatedAtQueryVariables,
  APITypes.TemplateTextboxesBySIDAndUpdatedAtQuery
>;
export const templateTextboxesByTIDAndUpdatedAt = /* GraphQL */ `query TemplateTextboxesByTIDAndUpdatedAt(
  $tID: ID!
  $updatedAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelTemplateTextboxFilterInput
  $limit: Int
  $nextToken: String
) {
  templateTextboxesByTIDAndUpdatedAt(
    tID: $tID
    updatedAt: $updatedAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      value
      section {
        id
        name
        isSimple
        tID
        subsectionOrder
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      sID
      template {
        id
        name
        pinned
        archived
        advanced
        lID
        sectionOrder
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      tID
      owners
      updatedAt
      createdAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.TemplateTextboxesByTIDAndUpdatedAtQueryVariables,
  APITypes.TemplateTextboxesByTIDAndUpdatedAtQuery
>;
export const getTemplateSubsection = /* GraphQL */ `query GetTemplateSubsection($id: ID!) {
  getTemplateSubsection(id: $id) {
    id
    name
    section {
      id
      name
      isSimple
      textboxes {
        nextToken
        startedAt
        __typename
      }
      template {
        id
        name
        pinned
        archived
        advanced
        lID
        sectionOrder
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      tID
      subsections {
        nextToken
        startedAt
        __typename
      }
      subsectionOrder
      owners
      updatedAt
      createdAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    sID
    fields {
      items {
        id
        name
        value
        ssID
        tID
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    fieldOrder
    template {
      id
      name
      pinned
      archived
      advanced
      location {
        id
        name
        address
        groupUsers
        groupAdmins
        groups
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      lID
      sections {
        nextToken
        startedAt
        __typename
      }
      sectionOrder
      subsections {
        nextToken
        startedAt
        __typename
      }
      fields {
        nextToken
        startedAt
        __typename
      }
      textboxes {
        nextToken
        startedAt
        __typename
      }
      owners
      updatedAt
      createdAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    tID
    owners
    updatedAt
    createdAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetTemplateSubsectionQueryVariables,
  APITypes.GetTemplateSubsectionQuery
>;
export const listTemplateSubsections = /* GraphQL */ `query ListTemplateSubsections(
  $filter: ModelTemplateSubsectionFilterInput
  $limit: Int
  $nextToken: String
) {
  listTemplateSubsections(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      name
      section {
        id
        name
        isSimple
        tID
        subsectionOrder
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      sID
      fields {
        nextToken
        startedAt
        __typename
      }
      fieldOrder
      template {
        id
        name
        pinned
        archived
        advanced
        lID
        sectionOrder
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      tID
      owners
      updatedAt
      createdAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListTemplateSubsectionsQueryVariables,
  APITypes.ListTemplateSubsectionsQuery
>;
export const syncTemplateSubsections = /* GraphQL */ `query SyncTemplateSubsections(
  $filter: ModelTemplateSubsectionFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncTemplateSubsections(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      name
      section {
        id
        name
        isSimple
        tID
        subsectionOrder
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      sID
      fields {
        nextToken
        startedAt
        __typename
      }
      fieldOrder
      template {
        id
        name
        pinned
        archived
        advanced
        lID
        sectionOrder
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      tID
      owners
      updatedAt
      createdAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncTemplateSubsectionsQueryVariables,
  APITypes.SyncTemplateSubsectionsQuery
>;
export const templateSubsectionsBySIDAndUpdatedAt = /* GraphQL */ `query TemplateSubsectionsBySIDAndUpdatedAt(
  $sID: ID!
  $updatedAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelTemplateSubsectionFilterInput
  $limit: Int
  $nextToken: String
) {
  templateSubsectionsBySIDAndUpdatedAt(
    sID: $sID
    updatedAt: $updatedAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      name
      section {
        id
        name
        isSimple
        tID
        subsectionOrder
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      sID
      fields {
        nextToken
        startedAt
        __typename
      }
      fieldOrder
      template {
        id
        name
        pinned
        archived
        advanced
        lID
        sectionOrder
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      tID
      owners
      updatedAt
      createdAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.TemplateSubsectionsBySIDAndUpdatedAtQueryVariables,
  APITypes.TemplateSubsectionsBySIDAndUpdatedAtQuery
>;
export const templateSubsectionsByTIDAndUpdatedAt = /* GraphQL */ `query TemplateSubsectionsByTIDAndUpdatedAt(
  $tID: ID!
  $updatedAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelTemplateSubsectionFilterInput
  $limit: Int
  $nextToken: String
) {
  templateSubsectionsByTIDAndUpdatedAt(
    tID: $tID
    updatedAt: $updatedAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      name
      section {
        id
        name
        isSimple
        tID
        subsectionOrder
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      sID
      fields {
        nextToken
        startedAt
        __typename
      }
      fieldOrder
      template {
        id
        name
        pinned
        archived
        advanced
        lID
        sectionOrder
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      tID
      owners
      updatedAt
      createdAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.TemplateSubsectionsByTIDAndUpdatedAtQueryVariables,
  APITypes.TemplateSubsectionsByTIDAndUpdatedAtQuery
>;
export const getTemplateField = /* GraphQL */ `query GetTemplateField($id: ID!) {
  getTemplateField(id: $id) {
    id
    name
    value
    subsection {
      id
      name
      section {
        id
        name
        isSimple
        tID
        subsectionOrder
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      sID
      fields {
        nextToken
        startedAt
        __typename
      }
      fieldOrder
      template {
        id
        name
        pinned
        archived
        advanced
        lID
        sectionOrder
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      tID
      owners
      updatedAt
      createdAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    ssID
    template {
      id
      name
      pinned
      archived
      advanced
      location {
        id
        name
        address
        groupUsers
        groupAdmins
        groups
        owners
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      lID
      sections {
        nextToken
        startedAt
        __typename
      }
      sectionOrder
      subsections {
        nextToken
        startedAt
        __typename
      }
      fields {
        nextToken
        startedAt
        __typename
      }
      textboxes {
        nextToken
        startedAt
        __typename
      }
      owners
      updatedAt
      createdAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    tID
    owners
    updatedAt
    createdAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetTemplateFieldQueryVariables,
  APITypes.GetTemplateFieldQuery
>;
export const listTemplateFields = /* GraphQL */ `query ListTemplateFields(
  $filter: ModelTemplateFieldFilterInput
  $limit: Int
  $nextToken: String
) {
  listTemplateFields(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      value
      subsection {
        id
        name
        sID
        fieldOrder
        tID
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      ssID
      template {
        id
        name
        pinned
        archived
        advanced
        lID
        sectionOrder
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      tID
      owners
      updatedAt
      createdAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListTemplateFieldsQueryVariables,
  APITypes.ListTemplateFieldsQuery
>;
export const syncTemplateFields = /* GraphQL */ `query SyncTemplateFields(
  $filter: ModelTemplateFieldFilterInput
  $limit: Int
  $nextToken: String
  $lastSync: AWSTimestamp
) {
  syncTemplateFields(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    lastSync: $lastSync
  ) {
    items {
      id
      name
      value
      subsection {
        id
        name
        sID
        fieldOrder
        tID
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      ssID
      template {
        id
        name
        pinned
        archived
        advanced
        lID
        sectionOrder
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      tID
      owners
      updatedAt
      createdAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SyncTemplateFieldsQueryVariables,
  APITypes.SyncTemplateFieldsQuery
>;
export const templateFieldsBySsIDAndUpdatedAt = /* GraphQL */ `query TemplateFieldsBySsIDAndUpdatedAt(
  $ssID: ID!
  $updatedAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelTemplateFieldFilterInput
  $limit: Int
  $nextToken: String
) {
  templateFieldsBySsIDAndUpdatedAt(
    ssID: $ssID
    updatedAt: $updatedAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      name
      value
      subsection {
        id
        name
        sID
        fieldOrder
        tID
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      ssID
      template {
        id
        name
        pinned
        archived
        advanced
        lID
        sectionOrder
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      tID
      owners
      updatedAt
      createdAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.TemplateFieldsBySsIDAndUpdatedAtQueryVariables,
  APITypes.TemplateFieldsBySsIDAndUpdatedAtQuery
>;
export const templateFieldsByTIDAndUpdatedAt = /* GraphQL */ `query TemplateFieldsByTIDAndUpdatedAt(
  $tID: ID!
  $updatedAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelTemplateFieldFilterInput
  $limit: Int
  $nextToken: String
) {
  templateFieldsByTIDAndUpdatedAt(
    tID: $tID
    updatedAt: $updatedAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      name
      value
      subsection {
        id
        name
        sID
        fieldOrder
        tID
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      ssID
      template {
        id
        name
        pinned
        archived
        advanced
        lID
        sectionOrder
        owners
        updatedAt
        createdAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      tID
      owners
      updatedAt
      createdAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    nextToken
    startedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.TemplateFieldsByTIDAndUpdatedAtQueryVariables,
  APITypes.TemplateFieldsByTIDAndUpdatedAtQuery
>;
